<template>
    <div class="row">
        <fieldset>
            <legend>Dados da Ação</legend>
            <div class="col s12">
                <label for="titulo">Título</label>
                <textarea
                    v-model="this.project.titulo"
                    disabled
                    class="active materialize-textarea"
                >
                </textarea>
            </div>
            <div class="col s12">
                <label for="cnpq">Código de área do CNPQ</label>
                <input
                    type="text"
                    disabled
                    id="cnpq"
                    v-model="this.project.area_cnpq"
                />
            </div>
            <div class="row col s12">
                <span>
                    <a
                        :href="`/projetos/pdf/${this.project.id}`"
                        target="_blank"
                        >PDF da Ação</a
                    >
                </span>
            </div>
            <div class="row col s12">
                <label for="resumo">Resumo</label>
                <textarea
                    v-model="this.project.resumo"
                    class="active materialize-textarea"
                    disabled
                    id="resumo"
                >
                </textarea>
            </div>
            <div class="row col s12">
                <label for="palavras-chave">Palavras-Chave</label>
                <input
                    id="palavras-chave"
                    disabled
                    v-model="this.project.palavras_chave"
                />
            </div>
            <bolsa
                :projectid="this.project.id"
                :disabled="true"
                v-if="this.project.id && this.project.bolsas"
            />
        </fieldset>
        <avaliacao-nota
            v-if="avaliacao"
            etapa="projeto"
            :title="msg"
            :avaliacao="avaliacao"
            legend="Avaliação da Ação"
            @set-nota="setNota"
            @submit="submit"
        />
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AvaliacaoNota from "./AvaliacaoNota.vue";
import Bolsa from "./Bolsa.vue";
import axios from "axios";
export default {
    name: "AvaliacaoProjeto",
    props: ["title"],
    data() {
        return {
            msg: JSON.parse(this.title).mensagem,
            notaTotal: 0
        };
    },
    components: {
        Bolsa,
        AvaliacaoNota
    },
    asyncComputed: {
        options: {
            async get() {
                try {
                    let { data: options } = await this.$http.get(
                        "/api/grupos/" + 1
                    );
                    return options;
                } catch (error) {
                    console.log(error);
                }
            },
            default: []
        }
    },
    computed: {
        avaliacao: {
            get() {
                try {
                    if (this.project.avaliacao.avaliacao_projeto != null) {
                        return JSON.parse(
                            this.project.avaliacao.avaliacao_projeto
                        );
                    } else {
                        let array = [];
                        if (this.options.length)
                            this.options.forEach((e, i) => {
                                e.nota = 0;
                                array.push(e);
                            });
                        return array;
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            set(value) {
                this.setAvaliacaoProjeto(value);
            }
        },
        ...mapState(["project"])
    },
    methods: {
        ...mapActions(["setAvaliacaoProjeto"]),

        setNota(newItem) {
            let index = this.avaliacao.findIndex(e => e.id == newItem);
            if (index > -1) {
                this.avaliacao.splice(index, 1);
                this.avaliacao.push(newItem);
            }
        },
        async submit(payload) {
            try {
                this.setAvaliacaoProjeto(JSON.stringify(payload));
                let { data, status } = await this.$http.post(
                    "/api/avaliacaoProjeto",
                    {
                        id: this.project.avaliacao.id,
                        avaliacao_projeto: payload
                    }
                );
                showMsg(data.msg, status);
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>
